import { useMemo } from "react";

import { skipToken } from "@reduxjs/toolkit/query";

import { useSwapRoutesQuery } from "../../reducers/loopIxsApi";
import { SwapRoutesParams } from "../../types";

/**
 * Configured pandora swap routes (`GET /swap-routes`). Only deliberately-configured pairs are
 * returned — empty for most tokens, so callers must treat "loading" and "no routes" identically.
 */
export function useSwapRoutesDomain({ outputMint, inputMint, skip }: SwapRoutesParams & { skip?: boolean }) {
    const request = useMemo(
        () => (outputMint || inputMint ? { outputMint, inputMint } : undefined),
        [outputMint, inputMint]
    );
    const { data } = useSwapRoutesQuery(request ?? skipToken, { skip: !request || skip });

    const routes = request && !skip ? data?.routes : undefined;
    // Enrichment: routes with an always-async step (e.g. epoch vault redemption) can never settle atomically.
    const atomicRoutes = useMemo(() => routes?.filter((route) => route.async !== true), [routes]);

    return { routes, atomicRoutes };
}
